import { Dropdown } from "antd";
import { DownOutlined, CopyOutlined, LoadingOutlined, CheckOutlined } from "@ant-design/icons";
import { useCallback, useState } from "react";
import { useFetchDynamicFields } from "../hooks/useFetchDynamicFields";

export default function DynamicFieldsDropdown() {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [isCopied, setIsCopied] = useState<boolean>(false);

  const copy = useCallback((text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    });
  }, []);

  const onCopyClick = useCallback(
    (field: { code: string }) => (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
      e.stopPropagation();
      copy(field.code);
      setIsOpen(false);
    },
    [copy]
  );

  const { isLoading, data } = useFetchDynamicFields();

  return isLoading ? (
    <>
      <p className="mx-2 text-md logo-cursor title dynamic-fields" onClick={(e) => e.preventDefault()}>
        <LoadingOutlined className="mr-1" /> Dynamic Fields <DownOutlined />
      </p>
    </>
  ) : isCopied ? (
    <>
      <p className="mx-2 text-md dynamic-fields copied">
        <CheckOutlined /> Copied
      </p>
    </>
  ) : (
    <Dropdown
      trigger={["click"]}
      placement="bottomLeft"
      open={isOpen}
      onOpenChange={(open) => setIsOpen(open)}
      dropdownRender={() => (
        <div className="dynamic-fields-dropdown">
          <div className="dropdown-header">Copy and paste into subject or message</div>
          <div className="dynamic-fields-container mx-2">
            {data?.map((field) => (
              <div key={field.code} className="dropdown-item" onClick={onCopyClick(field)}>
                <div>
                  <span className="description">{field.description}</span>
                  <span className="token">{field.code}</span>
                </div>
                <CopyOutlined className="text title logo-cursor" />
              </div>
            ))}
          </div>
        </div>
      )}
    >
      <p className="mx-2 text-md logo-cursor title dynamic-fields" onClick={(e) => e.preventDefault()}>
        Dynamic Fields <DownOutlined />
      </p>
    </Dropdown>
  );
}
